/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const Map: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m21 3.3516-1.0547.4687-4.9687 2.1328L9.2578 3.797l-.2812-.0938-.2813.1172-5.25 2.25L3 6.2578v14.3907l1.0547-.4688 4.9687-2.1328 5.7188 2.1562.2812.0938.2813-.1172 5.25-2.25.4453-.1875zM9.75 5.578l4.5 1.6875V18.422l-4.5-1.6875zm-1.5.047v11.1327L4.5 18.375V7.2422zm11.25 0v11.1327l-3.75 1.6172V7.2422z"/></svg>
);

export default Map;
